"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.function.name");

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("../../constants");

var _GridUtils = require("../../utils/GridUtils");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _Base = _interopRequireDefault(require("../base/Base"));

var _Components = _interopRequireDefault(require("../Components"));

var _NestedComponent = _interopRequireDefault(require("../nested/NestedComponent"));

var _Table = _interopRequireDefault(require("../table/Table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var EditGridComponent =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(EditGridComponent, _WithLogic);

  _createClass(EditGridComponent, [{
    key: "loadRefs",
    value: function loadRefs(element, refs) {
      for (var ref in refs) {
        if (refs[ref] === 'single') {
          this.refs[ref] = element.querySelector("[ref=\"".concat(ref, "\"]"));
        } else {
          this.refs[ref] = element.querySelectorAll("[ref=\"".concat(ref, "\"]"));
        }
      }

      var massageContainerRef = 'messageContainer';

      if (refs["".concat(massageContainerRef)] === 'single') {
        this.refs["".concat(massageContainerRef)] = _toConsumableArray(element.children).filter(function (elem) {
          return elem.attributes.ref.value === massageContainerRef;
        })[0];
      }
    }
  }, {
    key: "defaultBorder",
    get: function get() {
      return '1px dotted rgb(204, 204, 204)';
    }
  }, {
    key: "userBorder",
    get: function get() {
      return "1px solid ".concat(this.blockedUserColor);
    }
  }, {
    key: "disabled",
    set: function set(disabled) {
      var _this2 = this;

      // Устанавливает disabled для всех дочерних элементов
      this.component.components.forEach(function (component) {
        component.disabled = disabled;
        component.blockedUser = _this2.blockedUser || _this2.component.blockedUser;
      });
    }
  }, {
    key: "defaultDialogTemplate",
    get: function get() {
      return "\n            <h3 ref=\"dialogHeader\" class=\"MuiTypography-root MuiTypography-h6 MuiDialogTitle-root\">".concat(this.t('removeDialogTitle'), "</h3>\n            <div class=\"MuiDialogActions-root\" style=\"display:flex; justify-content: flex-end;\">\n              <button ref=\"dialogCancelButton\" class=\"MuiButtonBase-root MuiButton-root MuiButton-contained\">\n                <span class=\"MuiButton-label\">").concat(this.t('Cancel'), "</span>\n                <span class=\"MuiTouchRipple-root\"></span>\n              </button>\n              <button ref=\"dialogYesButton\" class=\"MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary\">\n                <span class=\"MuiButton-label\">").concat(this.t('Delete'), "</span>\n                <span class=\"MuiTouchRipple-root\"></span>\n              </button>\n            </div>\n        ");
    }
  }], [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _NestedComponent.default.schema.apply(_NestedComponent.default, [{
        type: 'editgrid',
        label: 'Edit Grid',
        key: 'editGrid',
        clearOnHide: true,
        input: true,
        tree: true,
        defaultOpen: false,
        removeRow: '',
        components: [],
        inlineEdit: false,
        templates: {
          header: this.defaultHeaderTemplate,
          row: this.defaultRowTemplate,
          footer: ''
        }
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Edit Grid',
        icon: 'fa fa-tasks',
        group: 'data',
        documentation: 'http://help.form.io/userguide/#editgrid',
        weight: 40,
        schema: EditGridComponent.schema()
      };
    }
  }, {
    key: "defaultHeaderTemplate",
    get: function get() {
      return "\n            <div class=\"row\">\n              {% util.eachComponent(components, function(component, index) { %}\n                <div\n                    class=\"col-sm-2\"\n                    style=\"{% if (instance.component.columnWidths && instance.component.columnWidths[index]) { %}\n                                width: {{ instance.component.columnWidths[index] }}px;\n                            {% } %}\"\n                >\n                    {{ component.label }}\n                </div>\n              {% }) %}\n              {% if (instance.value.length && !instance.options.readOnly) { %}\n                <div class=\"col-sm-2\"></div>\n              {% } %}\n            </div>\n        ";
    }
  }, {
    key: "defaultRowTemplate",
    get: function get() {
      return "\n        <div class=\"row\">\n          {% util.eachComponent(components, function(component, index) { %}\n          {% if (component.type !== 'categoryFile') { %}\n          <div class=\"col-sm-2\" title='{{ row[component.key] }}' style=\"display: -webkit-box;\n                                      -webkit-line-clamp: {{instance.originalComponent.rowsCount}};\n                                      -moz-box-orient: vertical;\n                                      -webkit-box-orient: vertical;\n                                      white-space: break-spaces;\n                                      {% if (instance.component.columnWidths && instance.component.columnWidths[index]) { %}\n                                          width: {{ instance.component.columnWidths[index] }}px;\n                                      {% } %}\n                                      \">{{ getView(component, row[component.key]) }}</div>\n          {% } else { %}\n          {{ getView(component, row[component.key]) }}\n          {% } %}\n          {% }) %}\n          {% if (!instance.options.readOnly) { %}\n          <div class=\"col-sm-2\">\n              <div class=\"btn-group pull-right\">\n                  <button title=\"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\" class=\"btn btn-default btn-sm editRow\"><span\n                          class=\"glyphicon glyphicon-edit\"></span></button>\n                  <button title=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C\" class=\"btn btn-danger btn-sm removeRow\"><span\n                          class=\"glyphicon glyphicon-trash\"></span></button>\n              </div>\n          </div>\n          {% } %}\n        </div>\n        ";
    }
  }]);

  function EditGridComponent(component, options, data) {
    var _this;

    _classCallCheck(this, EditGridComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditGridComponent).call(this, component, options, data));
    _this.type = 'datagrid';
    _this.editRows = [];
    _this.isCanAddRow = true;
    return _this;
  }

  _createClass(EditGridComponent, [{
    key: "build",
    value: function build(state) {
      var _this3 = this;

      if (this.options.builder) {
        return _get(_getPrototypeOf(EditGridComponent.prototype), "build", this).call(this, state, true);
      }

      this.createElement();
      this.addBlockByWrapper();

      if (this.shouldDisable) {
        this.disabled = true;
        this.element.setAttribute('tabIndex', '-1');
      } else {
        this.disabled = false;
        this.element.removeAttribute('tabIndex');
      }

      this.createLabel(this.element);
      var dataValue = this.dataValue;

      if (Array.isArray(dataValue)) {
        // Ensure we always have rows for each dataValue available.
        dataValue.forEach(function (row, rowIndex) {
          if (_this3.editRows[rowIndex]) {
            _this3.editRows[rowIndex].data = row;
          } else {
            _this3.editRows[rowIndex] = {
              components: [],
              isOpen: !!_this3.options.defaultOpen,
              data: row
            };
          }
        });
      }

      this.buildTable();
      this.createAddButton();
      this.createDescription(this.element);
      this.element.appendChild(this.errorContainer = this.ce('div', {
        class: 'has-error'
      }));
      this.attachLogic();
    }
  }, {
    key: "buildTable",
    value: function buildTable(fromBuild) {
      var _this4 = this;

      this.dataReady.then(function () {
        // Do not show the table when in builder mode.
        if (_this4.options.builder) {
          return;
        }

        if (!fromBuild && !_this4.editRows.length && _this4.component.defaultOpen) {
          return _this4.addRow(true);
        }

        var tableClass = 'editgrid-listgroup list-group ';
        ['striped', 'bordered', 'hover', 'condensed'].forEach(function (prop) {
          if (_this4.component[prop]) {
            tableClass += "table-".concat(prop, " ");
          }
        });

        var tableElement = _this4.ce('ul', _objectSpread({
          class: tableClass
        }, _this4.shouldDisable && {
          style: "pointer-events: none; border: ".concat(_this4.userBorder, "; border-bottom: ").concat(_this4.defaultBorder),
          tabIndex: '-1'
        }), [_this4.headerElement = _this4.createHeader(), _this4.rowElements = _this4.editRows.map(_this4.createRow.bind(_this4)), _this4.footerElement = _this4.createFooter()]);

        if (_this4.tableElement && _this4.element.contains(_this4.tableElement)) {
          _this4.element.replaceChild(tableElement, _this4.tableElement);
        } else {
          _this4.element.appendChild(tableElement);
        } //add open class to the element if any edit grid row is open


        var isAnyRowOpen = _this4.editRows.some(function (row) {
          return row.isOpen;
        });

        if (isAnyRowOpen) {
          _this4.addClass(_this4.element, "formio-component-".concat(_this4.component.type, "-row-open"));
        } else {
          _this4.removeClass(_this4.element, "formio-component-".concat(_this4.component.type, "-row-open"));
        }

        _this4.tableElement = tableElement;

        if (_this4.allowReorder) {
          _this4.addDraggable([_this4.tableElement]);
        }

        _this4.addFullScreenMode();

        (0, _GridUtils.toggleAddButton)(_this4.editRows.length, _this4);
      });
    }
  }, {
    key: "getRowDragulaOptions",
    value: function getRowDragulaOptions() {
      var superOptions = _get(_getPrototypeOf(EditGridComponent.prototype), "getRowDragulaOptions", this).call(this);

      superOptions.accepts = function (draggedElement, newParent, oldParent, nextSibling) {
        //disallow dragging above Edit Grid header
        return !nextSibling || !nextSibling.classList.contains('formio-edit-grid-header');
      };

      return superOptions;
    }
  }, {
    key: "onRowDrop",
    value: function onRowDrop(droppedElement, newParent, oldParent, nextSibling) {
      _get(_getPrototypeOf(EditGridComponent.prototype), "onRowDrop", this).call(this, droppedElement, newParent, oldParent, nextSibling);

      this.triggerChange();
    } // Добавил стандартный шаблон для хэдера, в котором при наличии строки в конец добавляется пустая ячейка
    // для коррекного отображения при малом кол-ве столбцов

  }, {
    key: "createHeader",
    value: function createHeader() {
      var templateHeader = _lodash.default.get(this.component, 'templates.header', EditGridComponent.defaultHeaderTemplate);

      if (!templateHeader) {
        return this.text('');
      }

      var headerMarkup = this.renderTemplate(templateHeader, {
        components: this.component.components,
        value: this.dataValue
      });
      var headerElement;

      if (this.allowReorder) {
        headerElement = this.ce('div', {
          class: 'row'
        }, [this.ce('div', {
          class: 'col-xs-1'
        }), this.ce('div', {
          class: 'col-xs-11'
        }, headerMarkup)]);
      } else {
        headerElement = headerMarkup;
      }

      return this.ce('li', {
        class: 'list-group-item list-group-header formio-edit-grid-header'
      }, headerElement);
    }
  }, {
    key: "createRow",
    value: function createRow(row, rowIndex) {
      var _this5 = this;

      var wrapper = this.ce('li', {
        class: 'list-group-item'
      });

      var rowTemplate = _lodash.default.get(this.component, 'templates.row', EditGridComponent.defaultRowTemplate);

      var isUseOldVersion = this.component.isUseOldVersion;

      if (!this.viewOnly && !isUseOldVersion) {
        row.isOpen = true;
      } // Store info so we can detect changes later.


      wrapper.rowData = row.data;
      wrapper.rowIndex = rowIndex;
      wrapper.rowOpen = row.isOpen;
      row.components = [];

      if (wrapper.rowOpen) {
        var editForm = isUseOldVersion ? this.component.components.map(function (comp) {
          var component = _lodash.default.cloneDeep(comp);

          var options = _lodash.default.clone(_this5.options);

          options.row = "".concat(_this5.row, "-").concat(rowIndex);
          options.name += "[".concat(rowIndex, "]"); // Добавляет флаг inEditGrid в дочерние элементы

          options.inEditGrid = true;

          if (component.type === _constants.componentTypes.categoryFile) {
            wrapper.style = 'align-self: stretch;';
          }

          var instance = _this5.createComponent(component, options, row.data);

          instance.rowIndex = rowIndex;
          row.components.push(instance);
          return instance.element;
        }) : this.createEditForm(row, rowIndex, wrapper);

        if (!this.options.readOnly) {
          var actionButtons = isUseOldVersion ? [this.ce('button', _objectSpread({
            class: 'btn btn-primary',
            onClick: this.saveRow.bind(this, rowIndex)
          }, this.shouldDisable && {
            disabled: 'disabled'
          }), this.component.saveRow || 'Save'), ' ', this.ce('button', _objectSpread({
            class: 'btn btn-danger',
            onClick: this.cancelRow.bind(this, rowIndex)
          }, this.shouldDisable && {
            disabled: 'disabled',
            style: 'color: #d0d5dd'
          }), this.component.removeRow || 'Cancel')] : this.ce('button', _objectSpread({
            class: 'btn btn-danger',
            onClick: this.removeRow.bind(this, rowIndex)
          }, this.shouldDisable && {
            disabled: 'disabled',
            style: 'color: #d0d5dd'
          }), this.component.removeRow || 'Delete');
          editForm.push(this.ce('div', {
            class: 'editgrid-actions'
          }, actionButtons));
        }

        wrapper.appendChild(this.ce('div', {
          class: 'editgrid-edit'
        }, this.ce('div', {
          class: 'editgrid-body'
        }, editForm)));
      } else {
        var rowMarkup = this.renderTemplate(rowTemplate, {
          row: row.data,
          data: this.data,
          rowIndex: rowIndex,
          components: this.component.components,
          t: function t(text, params) {
            return _this5.t(text, params);
          },
          getView: function getView(component, data) {
            var componentCopy = _objectSpread({}, component);

            if (!data) {
              data = '-';
              componentCopy.type = 'textfield';
              delete componentCopy.format;
              delete componentCopy.widget;
            }

            componentCopy.form = _this5.data;

            var options = _lodash.default.clone(_this5.options);

            options.row = "".concat(_this5.row, "-").concat(rowIndex);
            options.name += "[".concat(rowIndex, "]");

            var createdComponent = _Components.default.create(componentCopy, options, data, true);

            var res = createdComponent.getView(data, createdComponent.options.name);

            var afterGetView = function afterGetView() {
              return setTimeout(function () {
                if (createdComponent.afterGetView) {
                  createdComponent.afterGetView();
                }
              }, 0);
            };

            if (res && res.then) {
              var rowId = _lodash.default.uniqueId('editGridTextComponent');

              res.then(function (result) {
                var componentElement = document.querySelector("#".concat(rowId));

                if (componentElement) {
                  componentElement.innerHTML = "<div>".concat(result, "</div>");
                }

                afterGetView();
              });

              if (createdComponent.type === _constants.componentTypes.categoryFile) {
                return '<div class="col-sm-2" style="width: 200px" id="' + rowId + '"></div>';
              }

              return '<div id="' + rowId + '"></div>';
            } else {
              afterGetView();
              return res;
            }
          }
        }, [{
          class: 'removeRow',
          event: 'click',
          action: this.removeRow.bind(this, rowIndex)
        }, {
          class: 'editRow',
          event: 'click',
          action: this.editRow.bind(this, rowIndex)
        }]);
        var rowElement;

        if (this.allowReorder) {
          rowElement = this.ce('div', {
            class: 'row'
          }, [this.ce('div', {
            class: 'col-xs-1 formio-drag-column'
          }, this.dragButton()), this.ce('div', {
            class: 'col-xs-11'
          }, rowMarkup)]);
        } else {
          rowElement = rowMarkup;
        }

        wrapper.appendChild(rowElement);
      }

      wrapper.appendChild(row.errorContainer = this.ce('div', {
        class: 'has-error'
      }));
      this.checkData(this.data, {
        noValidate: true
      }, rowIndex);

      if (this.allowReorder) {
        wrapper.dragInfo = {
          index: rowIndex
        };
      }

      return wrapper;
    }
  }, {
    key: "createEditForm",
    value: function createEditForm(row, rowIndex, wrapper) {
      var _this6 = this;

      return this.component.components.map(function (comp) {
        var component = _lodash.default.cloneDeep(comp);

        var options = _lodash.default.clone(_this6.options);

        options.row = "".concat(_this6.row, "-").concat(rowIndex);
        options.name += "[".concat(rowIndex, "]"); // Добавляет флаг inEditGrid в дочерние элементы

        options.inEditGrid = true;

        if (component.type === _constants.componentTypes.categoryFile && wrapper) {
          wrapper.style = 'align-self: stretch;';
        }

        var instance = _this6.createComponent(component, options, row.data);

        instance.rowIndex = rowIndex;
        var instanceElement = instance.element.lastChild;
        row.components.push(instance);
        instanceElement.addEventListener('change', function (event) {
          if (instance.fileLoaded) {
            return instance.fileLoaded.then(function () {
              _this6.updateValueIfNotEmpty(rowIndex);
            });
          }

          return _this6.updateValueIfNotEmpty(rowIndex);
        });
        return instance.element;
      });
    }
  }, {
    key: "updateValueIfNotEmpty",
    value: function updateValueIfNotEmpty(rowIndex) {
      var editRow = this.editRows[rowIndex];
      var rowData = editRow.data;
      var values = Object.values(rowData).join('').trim();

      if (values) {
        this.dataValue[rowIndex] = rowData;
      } else {
        this.dataValue.splice(rowIndex, 1);
      }
    }
  }, {
    key: "createFooter",
    value: function createFooter() {
      var footerTemplate = _lodash.default.get(this.component, 'templates.footer');

      if (!footerTemplate) {
        return this.text('');
      }

      return this.ce('li', {
        class: 'list-group-item list-group-footer'
      }, this.renderTemplate(footerTemplate, {
        components: this.component.components,
        value: this.dataValue
      }));
    }
  }, {
    key: "checkData",
    value: function checkData(data) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var valid = true;

      if (flags.noCheck) {
        return;
      } // Update the value.


      var changed = this.updateValue({
        noUpdateEvent: true
      });
      var editRow = this.editRows[index]; // Iterate through all components and check conditions, and calculate values.

      editRow.components.forEach(function (comp) {
        changed |= comp.calculateValue(data, {
          noUpdateEvent: true
        });
        comp.checkConditions(data);

        if (!flags.noValidate) {
          valid &= comp.checkValidity(data, !editRow.isOpen);
        }
      });
      valid &= this.validateRow(index); // Trigger the change if the values changed.

      if (changed) {
        this.triggerChange(flags);
      } // Return if the value is valid.


      return valid;
    }
  }, {
    key: "createAddButton",
    value: function createAddButton() {
      var _this7 = this;

      this.dataReady.then(function () {
        if (_this7.options.readOnly) {
          return;
        }

        _this7.element.appendChild(_this7.ce('div', {
          class: 'add-btn-wrapper'
        }, [_this7.ce('div', _objectSpread({
          class: 'editgrid-add',
          style: "".concat(_this7.shouldDisable ? "border: ".concat(_this7.userBorder, "; border-top: ").concat(_this7.defaultBorder, ";") : '', " border-bottom: none;")
        }, _this7.shouldDisable && {
          disabled: 'disabled'
        }), _this7.ce('button', _objectSpread({
          class: 'btn btn-primary',
          role: 'button',
          onClick: _this7.addRow.bind(_this7)
        }, _this7.shouldDisable && {
          disabled: 'disabled'
        }), [_this7.ce('span', {
          class: _this7.iconClass('plus'),
          'aria-hidden': true
        }), ' ', _this7.t(_this7.component.addAnother ? _this7.component.addAnother : 'Add Another', {})])), _this7.ce('div', {
          class: 'editgrid-add',
          style: "padding: 0px 10px;\n                                 ".concat(_this7.shouldDisable ? "border: ".concat(_this7.userBorder, ";") : '', " border-top: none;")
        }, _this7.ce('p', {
          class: 'add-btn-message'
        }))]));
      });
    }
  }, {
    key: "addRow",
    value: function addRow(fromBuild) {
      this.fullscreen = false;

      if (this.isCanAddRow) {
        if (this.options.readOnly) {
          return;
        }

        var dataObj = {};
        this.editRows.push({
          components: [],
          isOpen: true,
          data: dataObj
        });

        if (this.component.inlineEdit) {
          this.dataValue.push(dataObj);
        }

        this.emit('editGridAddRow', {
          component: this.component,
          row: this.editRows[this.editRows.length - 1]
        });

        if (this.component.inlineEdit) {
          this.updateGrid();
        } else {
          this.buildTable(fromBuild);
        }

        if (!this.component.isUseOldVersion) {
          var rowIndex = this.editRows.length - 1;
          this.dataValue.push(this.editRows[rowIndex].data);
        }

        (0, _GridUtils.toggleAddButton)(this.editRows.length + 1, this);
      }
    }
  }, {
    key: "editRow",
    value: function editRow(rowIndex) {
      var editRow = this.editRows[rowIndex];
      editRow.dirty = false;
      editRow.isOpen = true;
      editRow.editing = true;

      var dataSnapshot = _lodash.default.cloneDeep(this.dataValue[rowIndex]);

      if (this.component.inlineEdit) {
        editRow.backup = dataSnapshot;
        this.updateGrid();
      } else {
        editRow.data = dataSnapshot;
        this.buildTable();
      }
    }
  }, {
    key: "updateGrid",
    value: function updateGrid() {
      this.updateValue();
      this.triggerChange();
      this.buildTable();
    }
  }, {
    key: "clearErrors",
    value: function clearErrors(rowIndex) {
      var editRow = this.editRows[rowIndex];

      if (editRow && Array.isArray(editRow.components)) {
        editRow.components.forEach(function (comp) {
          comp.setPristine(true);
          comp.setCustomValidity('');
        });
      }
    }
  }, {
    key: "cancelRow",
    value: function cancelRow(rowIndex) {
      var editRow = this.editRows[rowIndex];

      if (this.options.readOnly) {
        editRow.dirty = false;
        editRow.isOpen = false;
        this.buildTable();
        return;
      }

      if (editRow.editing) {
        editRow.dirty = false;
        editRow.isOpen = false;

        if (this.component.inlineEdit) {
          this.dataValue[rowIndex] = editRow.backup;
        }

        editRow.data = this.dataValue[rowIndex];
        this.clearErrors(rowIndex);
      } else {
        this.clearErrors(rowIndex);

        if (this.component.inlineEdit) {
          this.splice(rowIndex);
        }

        this.removeChildFrom(editRow.element, this.tableElement);
        this.editRows.splice(rowIndex, 1);
      }

      this.updateGrid();
    }
  }, {
    key: "saveRow",
    value: function saveRow(rowIndex) {
      var editRow = this.editRows[rowIndex];

      if (this.options.readOnly) {
        editRow.dirty = false;
        editRow.isOpen = false;
        this.buildTable();
        return;
      }

      editRow.dirty = true;

      if (!this.validateRow(rowIndex)) {
        return;
      }

      editRow.dirty = false;
      editRow.isOpen = false;

      if (!this.component.inlineEdit) {
        if (editRow.editing) {
          this.dataValue[rowIndex] = editRow.data;
        } else {
          // Insert this row into its proper place.
          var newIndex = this.dataValue.length;
          this.dataValue.push(editRow.data);
          this.editRows.splice(rowIndex, 1);
          this.editRows.splice(newIndex, 0, editRow);
        }
      }

      this.updateGrid();
    }
  }, {
    key: "removeRow",
    value: function removeRow(rowIndex) {
      this.triggerUpdateByUser();

      if (this.options.readOnly) {
        return;
      }

      if (this.originalComponent.enableRemoveDialog) {
        this.showRemoveModal(rowIndex);
        return;
      }

      this.removeRowModal(rowIndex);
      this.triggerChange({
        modified: true
      }, false, false);
    }
  }, {
    key: "showRemoveModal",
    value: function showRemoveModal(rowIndex) {
      var _this8 = this;

      var editRow = this.editRows[rowIndex];
      editRow.willBeSaved = false;
      var dialog = this.createModal();
      var wrapper = dialog.bodyContainer;
      dialog.classList.add("editgrid-row-modal-".concat(this.id));
      wrapper.innerHTML = this.defaultDialogTemplate;
      wrapper.refs = {};
      this.loadRefs.call(wrapper, wrapper, {
        dialogHeader: 'single',
        dialogCancelButton: 'single',
        dialogYesButton: 'single'
      });
      editRow.dialog = dialog;

      var close = function close(event) {
        event.preventDefault();
        dialog.close();
      };

      this.addEventListener(wrapper.refs.dialogYesButton, 'click', function (event) {
        close(event);

        _this8.removeRowModal(rowIndex);
      });
      this.addEventListener(wrapper.refs.dialogCancelButton, 'click', function (event) {
        close(event);
      });
    }
  }, {
    key: "removeRowModal",
    value: function removeRowModal(rowIndex) {
      this.splice(rowIndex);
      this.removeChildFrom(this.editRows[rowIndex].element, this.tableElement);
      this.editRows.splice(rowIndex, 1);
      this.updateGrid();
      (0, _GridUtils.toggleAddButton)(this.editRows.length - 1, this);
    }
  }, {
    key: "validateRow",
    value: function validateRow(rowIndex, dirty) {
      var check = true;
      var editRow = this.editRows[rowIndex];
      var isDirty = dirty || !!editRow.dirty;

      if (!editRow.components.length) {
        this.createEditForm(editRow, rowIndex);
      }

      editRow.components.forEach(function (comp) {
        check &= comp.checkValidity(null, isDirty, editRow.data);
      });

      if (this.component.validate && this.component.validate.row) {
        var valid = this.evaluate(this.component.validate.row, {
          valid: true,
          row: editRow.data
        }, 'valid', true);

        if (valid === null) {
          valid = "Invalid row validation for ".concat(this.key);
        }

        editRow.errorContainer.innerHTML = '';

        if (valid !== true) {
          editRow.errorContainer.appendChild(this.ce('div', {
            class: 'editgrid-row-error help-block'
          }, valid));
          return false;
        }
      }

      return check;
    }
  }, {
    key: "checkValidity",
    value: function checkValidity(data, dirty) {
      var _this9 = this;

      if (!this.checkCondition(null, data)) {
        this.setCustomValidity('');
        return true;
      }

      var rowsValid = true;
      var rowsClosed = true;
      this.editRows.forEach(function (editRow, rowIndex) {
        // Trigger all errors on the row.
        var rowValid = _this9.validateRow(rowIndex, dirty); // Add has-error class to row.


        if (!rowValid) {
          _this9.addClass(editRow.element, 'has-error');
        } else {
          _this9.removeClass(editRow.element, 'has-error');
        }

        rowsValid &= rowValid; // Any open rows causes validation to fail.

        if (dirty) {
          rowsClosed &= !editRow.isOpen;
        }
      });

      if (!rowsValid) {
        this.setCustomValidity(this.t('fillCorrectly'), dirty);
        return false;
      }

      var message = this.invalid || this.invalidMessage(data, dirty);
      this.setCustomValidity(message, dirty);
      return message ? false : true;
    }
  }, {
    key: "setCustomValidity",
    value: function setCustomValidity(message, dirty) {
      if (this.errorElement && this.errorContainer) {
        this.errorElement.innerHTML = '';
        this.removeChildFrom(this.errorElement, this.errorContainer);
      }

      if (this.options.highlightErrors) {
        this.removeClass(this.element, 'alert alert-danger');
      }

      if (message) {
        this.emit('componentError', this.error);
        this.createErrorElement();
        var errorMessage = this.ce('p', {
          class: 'help-block'
        });
        errorMessage.appendChild(this.text(message));
        this.appendTo(errorMessage, this.errorElement);

        if (dirty && this.options.highlightErrors) {
          this.addClass(this.element, 'alert alert-danger');
        }
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(flags, value) {
      // Intentionally skip over nested component updateValue method to keep recursive update from occurring with sub components.
      return _Base.default.prototype.updateValue.call(this, flags, value);
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this10 = this;

      if (!value) {
        this.editRows = this.defaultValue;
        this.buildTable();
        return;
      }

      if (!Array.isArray(value)) {
        if (_typeof(value) === 'object') {
          value = [value];
        } else {
          return;
        }
      }

      var changed = this.hasChanged(value, this.dataValue);
      this.dataValue = value;
      var dataValue = this.dataValue;

      if (Array.isArray(dataValue)) {
        // Refresh editRow data when data changes.
        dataValue.forEach(function (row, rowIndex) {
          if (_this10.editRows[rowIndex]) {
            _this10.editRows[rowIndex].data = row;
          } else {
            _this10.editRows[rowIndex] = {
              components: [],
              isOpen: !!_this10.options.defaultOpen,
              data: row
            };
          }
        }); // Remove any extra edit rows.

        if (dataValue.length < this.editRows.length) {
          for (var rowIndex = this.editRows.length - 1; rowIndex >= dataValue.length; rowIndex--) {
            this.removeChildFrom(this.editRows[rowIndex].element, this.tableElement);
            this.editRows.splice(rowIndex, 1);
          }
        }
      }

      this.buildTable();
      return changed;
    }
    /**
     * Get the value of this component.
     *
     * @returns {*}
     */

  }, {
    key: "getValue",
    value: function getValue() {
      return this.dataValue;
    }
  }, {
    key: "clearOnHide",
    value: function clearOnHide(show) {
      _get(_getPrototypeOf(EditGridComponent.prototype), "clearOnHide", this).call(this, show);

      if (!this.component.clearOnHide) {
        // If some components set to clearOnHide we need to clear them.
        this.buildTable();
      }
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(before, after) {
      return !_lodash.default.isEqual(before, after);
    }
  }, {
    key: "restoreComponentsContext",
    value: function restoreComponentsContext() {
      return;
    }
  }, {
    key: "unblockByUser",
    value: function unblockByUser() {
      if (this.disabledByUser) {
        this.component.blockedUser = undefined;
      }

      _get(_getPrototypeOf(EditGridComponent.prototype), "unblockByUser", this).call(this);
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return EditGridComponent.schema();
    }
  }, {
    key: "emptyValue",
    get: function get() {
      return [];
    }
  }, {
    key: "shouldDisable",
    get: function get() {
      // В режиме viewOnly не добавлять стили для disabled
      return this.disabledByUser || this.component.disabled && !this.component.alwaysEnabled && !this.viewOnly;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      var value = _get(_getPrototypeOf(EditGridComponent.prototype), "defaultValue", this);

      return Array.isArray(value) ? value : [];
    }
  }]);

  return EditGridComponent;
}((0, _WithLogic2.default)(_NestedComponent.default));

exports.default = EditGridComponent;
EditGridComponent.prototype.addFullScreenMode = _Table.default.prototype.addFullScreenMode;
EditGridComponent.prototype.toggleFullScreenMode = _Table.default.prototype.toggleFullScreenMode;